import React,{ useEffect, useState } from 'react';
import styles from '../styles.scss';
import BottomBar from './BottomBar';
import { courseLike,courseCollect,courseShare } from '@/services/course';
import { Toast } from 'antd-mobile';


export default (props) => {
  const {course, goComment} = props;

  const [isLike,setIsLike] = useState(course.isLike);
  const [isCollect,setIsCollect] = useState(course.isCollect);





  return(
    <div className={styles.tabBox}>
      <div className={styles.tabCenter}>
       <div className={styles.htmlContent} dangerouslySetInnerHTML={{ __html: course.content }}></div>
      </div>
      <BottomBar course={course} isLike={isLike} isCollect={isCollect} onClick={(i) => {
        switch (i) {
          case 0:
            goComment && goComment();
            break;
          case 1:
            like();
            break;
          case 2:
            share();
            break;
          case 3:
            collect();
            break;
        }
      }}/>
    </div>
  )

  function like() {
    courseLike({courseId:course.id}).then(res => {

      if (res.code == 200) {
        setIsLike(isLike == '0' ? '1' : '0');
        Toast.success(res.data,1);
      } else {
        Toast.fail(res.message,1);

      }
    }).catch(e => {
      Toast.fail('请求失败，请重试',1);

    });
  }

  function share() {

  }

  function collect() {
    courseCollect({courseId:course.id}).then(res => {
      console.log(res);
      if (res.code == 200) {
        setIsCollect(isCollect == '0' ? '1' : '0');
        Toast.success(res.data,1);
      } else {
        Toast.fail(res.message,1);

      }
    }).catch(e => {
      Toast.fail('请求失败，请重试',1);

    });
  }
}
